const SUPPORTED_LOCALES = {
  EN_US: 'en-US',
  EN_GB: 'en-GB',
  EN_EU: 'en-EU',
  FR_FR: 'fr-FR',
  DE_DE: 'de-DE',
  NL_NL: 'nl-NL',
  IT_IT: 'it-IT',
};

const DEFAULT_LOCALE = SUPPORTED_LOCALES.EN_US;

export { DEFAULT_LOCALE, SUPPORTED_LOCALES };
